<template>
  <span v-if="diff !== 0" :class="colorClass">
    <v-icon :class="colorClass">{{ icon }}</v-icon>({{ Number(percentageDiff.toFixed(2)) }}%)
  </span>
</template>

<script>
export default {
  name: "ValuesPercentageDiff",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    prevValue: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    diff() {
      return this.value - this.prevValue;
    },
    percentageDiff() {
      return this.diff / (this.prevValue || 1) * 100;
    },
    icon() {
      return this.diff > 0 ? 'mdi-arrow-up' : 'mdi-arrow-down';
    },
    colorClass() {
      return this.diff > 0 ? 'teal--text text--darken-2' : 'red--text text--accent-4';
    }
  },
}
</script>

<style scoped>

</style>